import { useMutation, UseMutationResult } from '@tanstack/react-query';

import { AxiosResponse } from 'axios';

import { Api, LoginResponse, useApi } from '@sbv-clients/data-access-api';
import { useSnackBar } from '@sbv-clients/ui-shared';
import { getApiErrorMessage } from '@sbv-clients/util-misc';

const loginToNewFacility = (api: Api) => (employeeId: string) => {
  return api.accountApi.accountSelectProfileTargetEmployeeIdPut({
    targetEmployeeId: employeeId,
    isWeb: true,
  });
};
export const useLoginToNewProfile = (): UseMutationResult<
  AxiosResponse<LoginResponse>,
  unknown,
  string
> => {
  const api = useApi();
  const { notifyError } = useSnackBar();

  return useMutation(loginToNewFacility(api), {
    onError: async (error) => {
      notifyError(getApiErrorMessage(error));
    },
  });
};
